$(function() {
	$('.select-text').click(function () {
		$('.select-text').not(this).removeClass('active').next().slideUp()
		$(this).toggleClass('active').next().slideToggle();
	});

	$('.select-dropdown__option').click(function () {
		// var value = $(this).attr('data-select');
		var value = $(this).text();
		console.log(value)
		$(this).parent().find('.select-dropdown__option').removeClass('active');
		$(this).addClass('active').closest('.select-dropdown').slideUp().end().closest('.select').find('.select-input').val(value).end().find('.select-text').toggleClass('active').find('span').text(value);
	});
})
